import { Money as MoneyIcon } from "@phosphor-icons/react";

export default MoneyIcon
